<template>
	<div class="bg_content">
		<div class="device_head">
			<span style="color: #b2b2b2">门禁管理 /</span>
			<span style="color: #5c5c5c"> 紧急开关门</span>
		</div>
		<div class="content_body">
			<el-card shadow="never" style="height: 80px;">
        <div style="display: flex;justify-content: space-between;align-items: center">
          <div style="display: flex;">
            <el-input style="margin-right: 10px" placeholder="设备名称、SN序列号" v-model="searchQuery.likeString" clearable></el-input>
            <el-select  placeholder="设备状态" v-model="searchQuery.status" clearable style="width: 100%;margin-right: 10px">
              <el-option v-for="(item,index) in statusList" :label="item.name" :value="item.id"></el-option>
            </el-select>
            <el-select placeholder="开关门方式" v-model="searchQuery.emergencyStatus" clearable style="width: 100%;margin-right: 10px">
              <el-option v-for="(item,index) in emergencyStatusList" :label="item.name" :value="item.value"></el-option>
            </el-select>
            <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
          </div>
          <div>
            <el-button style="margin-right: 10px" @click="handleEmergencyOpenDoor('',1)" type="danger" icon="el-icon-lock">紧急开门</el-button>
            <el-button style="margin-right: 10px" @click="handleEmergencyOpenDoor('',2)" type="warning" icon="el-icon-unlock">紧急关门</el-button>
            <el-button style="margin-right: 10px" @click="handleEmergencyOpenDoor('',0)" type="primary" icon="el-icon-refresh">恢复自动控制</el-button>
            <el-button icon="el-icon-s-ticket" @click="$router.replace('/history/emergencyOpenDoorHistory')"> 开关门记录</el-button>
          </div>
        </div>

			</el-card>
			<el-card class="card_table" shadow="never">
				<el-table :data="tableData" :header-cell-style="{background: '#F5F6FA',color: '#5C5C5C',}" height="580"
					@selection-change="handleSelectionChange">
					<template slot="empty">
						<div>
							<img src="@/assets/nodata.png" class="nodata" />
							<div class="nodata_text">无数据</div>
						</div>
					</template>
					<el-table-column type="selection"></el-table-column>
					<el-table-column label="设备名称" prop="name" />
					<el-table-column label="SN序列号" prop="sn" />
					<el-table-column label="设备类型" prop="type" :formatter="typeFormatter" />
					<el-table-column label="设备状态" prop="status">
            <template slot-scope="{row}">
              <span style="color:#0caf7b;" v-if="row.status == 1">在线</span>
              <span style="color:#f0142f;" v-else>离线</span>
            </template>
          </el-table-column>
          <el-table-column label="门状态" prop="magneticStatus">
            <template slot-scope="{row}">
              <span style="color:#0caf7b;" v-if="row.magneticStatus == 1">开</span>
              <span style="color:#E6A23C;" v-else>关</span>
            </template>
          </el-table-column>
					<el-table-column label="设备用途" prop="equipmentUsageType" :formatter="usageTypeFormatter"/>
					<el-table-column label="开关门方式" prop="emergencyStatus" >
            <template slot-scope="{row}">
              <span style="color:#F56C6C;" v-if="row.emergencyStatus == 1">紧急开门</span>
              <span style="color:#E6A23C;" v-else-if="row.emergencyStatus == 2">紧急关门</span>
              <span style="color:#409EFF;" v-else>自动控制</span>
            </template>
          </el-table-column>
					<el-table-column label="IP地址" prop="ip"></el-table-column>
					<el-table-column label="操作" width="300">
						<template slot-scope="{row}">
							<el-link type="primary" @click="handleEmergencyOpenDoor([row.id],1)" style="margin-right: 25px;color:#F56C6C;" v-if="row.emergencyStatus !== 1">紧急开门</el-link>
              <el-link type="primary" @click="handleEmergencyOpenDoor([row.id],2)" style="margin-right: 25px;color:#E6A23C;" v-if="row.emergencyStatus !== 2">紧急关门</el-link>
              <el-link type="primary" @click="handleEmergencyOpenDoor([row.id],0)" style="margin-right: 25px;color:#409EFF;" v-if="row.emergencyStatus !== 0">自动控制</el-link>
            </template>
					</el-table-column>
				</el-table>
				<el-pagination style="margin-top: 10px;" v-model:current-page="searchQuery.pageNum" :page-size="searchQuery.pageSize"
					layout="total, ->, prev, pager, next" :total="tableTotal" @current-change="handleCurrentChange" />
			</el-card>
		</div>

		<company-footer-info />
	</div>
</template>

<script>
	import CompanyFooterInfo from "@/components/companyFooterInfo.vue";
	import {
		NexusCommandApi
	} from "@/api/nexus/command";
	import {
		NexusDeviceApi
	} from "@/api/nexus/device";
	export default {
		components: {
			CompanyFooterInfo,
		},
		data() {
			return {
				//查询条件
				searchQuery: {
					likeString: '',
					pageSize: 20,
					pageNum: 1,
				},
        statusList: [{id:0,name:'离线'},{id:1,name:'在线'}],
        emergencyStatusList: [
          {value:0,name:'自动控制'},
          {value:1,name:'紧急开门'},
          {value:2,name:'紧急关门'}
        ],
				//表格数据
				tableData: [],
				tableTotal: 0,
				selectDeviceIds: [],
			}
		},
		methods: {
			usageTypeFormatter(row){
				let statusList = [{id:1,name:'考勤'},{id:2,name:'门禁'},{id:3,name:'考勤+门禁'}]
				return statusList.find(item => {
					return item.id === row.equipmentUsageType
				}).name
			},
			//类型格式化
			typeFormatter(row) {
				let typeList = [{
						id: 0,
						name: '指纹系列'
					},
					{
						id: 1,
						name: '近红外人脸考勤机'
					},
					{
						id: 2,
						name: '动态人脸考勤机'
					},
					{
						id: 3,
						name: '近红外人脸门禁机'
					},
					{
						id: 4,
						name: '动态人脸门禁机'
					},
				];
				return typeList.find(item => {
					return item.id === row.type
				}).name
			},
			handleSelectionChange(arr) {
				this.selectDeviceIds = arr?.map(item => item.id);
			},
			handleSearch(){
				this.searchQuery.pageNum = 1;
				this.getDoorList();
			},
			//下一页
			handleCurrentChange(page) {
				this.searchQuery.pageNum = page;
				this.getDoorList();
			},
			//获取数据
			async getDoorList() {
				let {
					code,
					data
				} = await NexusDeviceApi.page(this.searchQuery)
				if (code == 200) {
					this.tableData = data.list;
					this.tableTotal = parseInt(data.total);
				}
			},
      handleEmergencyOpenDoor(deviceIdList, controlWay) {
        if(!deviceIdList){
          deviceIdList = this.selectDeviceIds;
        }
        if(deviceIdList && deviceIdList.length > 0){
          this.$confirm("确定要执行此操作吗？", "确认框",{}).then(() => {
            NexusCommandApi.batchNexusEmergencyOpenDoor( {deviceIdList:deviceIdList,controlWay:controlWay}).then(response => {
              let {code,message} = response;
              if(200 == code){
                this.$message.success("指令发送成功");
                this.getDoorList();
              }else{
                this.$message.error(message);
              }
            })
          }).catch(() => {

          });
        }else {
          this.$message.error("请选择设备");
        }


      },
		},
		mounted() {
			this.getDoorList();
		}
	}
</script>

<style>
	.bg_content {
		width: 100%;
		padding: 16px 20px;
		background: #f4f7fc;
		height: 100%;
		display: flex;
		flex-direction: column;
		box-sizing: border-box;
	}

	.content_body {
		margin-top: 20px;
		height: 100%;
	}

	.table_scope_t {
		color: #4192F3;
	}

	.table_scope_f {
		color: #EE7B32;
	}

	.time_single {
		flex: 0 0 116px;
		/* 不伸缩，基准宽度 116px */
		width: 100px;
		/* 实际宽度 100px */
		height: 30px;
		line-height: 30px;
		text-align: center;
		font-size: 16px;
		color: #1a1a1a;
		background: #dee4ed;
		border-radius: 4px;
		margin-right: 8px;
		white-space: nowrap !important;
		overflow: hidden !important;
		text-overflow: ellipsis !important;

	}

	.card_table {
		height: calc(100% - 80px) !important;
	}

	.search-icon {
		width: 18px;
		height: 18px;
		vertical-align: middle;
	}
</style>